export default __webpack_public_path__ + "static/media/img4.c7921cd9.jpg";